import {translate} from 'i18n'
import {GiftshopProfileSocialMediaType} from 'types'

export function transformSocialType(item?: GiftshopProfileSocialMediaType) {
  switch (item) {
    case 'twitter':
      return 'X'
    case 'tiktok':
      return 'TikTok'
    case 'linkedin':
      return 'LinkedIn'
    case 'whatsapp':
      return 'WhatsApp'
    case 'other':
      return translate('global:other')
    default:
      return item ? item.charAt(0).toUpperCase() + item.substring(1) : ''
  }
}
